import React from 'react';
import { Grid, Paper } from '@mui/material';
import { useSelector } from 'store/hooks';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';
import { GridSortModel } from '@mui/x-data-grid-pro';
import StatusMatrixFinacialKpi from 'components/DashboardComponents/DashboardListTable/StatusMatrixFinacialKpi';

type KpiMetricsFinancialTableProps = {
  currencies: any;
  selectedCurrency: any;
  barChartData: any;
  metric: any;
  data_table: any;
  onDownloadXlsx?: () => void;
  showDownload?: boolean;
};

const KpiMetricsFinancialTable = ({
  currencies,
  selectedCurrency,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}: KpiMetricsFinancialTableProps) => {
  const { loadings } = useSelector((state) => state);
  const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
  const matchedCurrency = currencies?.find((c: any) => c.name.toLowerCase() === selectedCurrency?.toLowerCase());
  const symbol = matchedCurrency?.symbol === 'E' || !matchedCurrency?.symbol ? '€' : matchedCurrency?.symbol;

  return (
    <>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <StatusMatrixFinacialKpi data={data_table?.price_table} symbol={symbol} showAllStatuses />
        </Grid>
      </Grid>

      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
              sortModel={sortModel}
              setSortModel={setSortModel}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsFinancialTable;
